module.exports = __webpack_public_path__ + "static/AtomicWallet-44c10ccbdcfd7ad5f4b8f1c318ff8524.png";